import { useEffect, useState } from "react";
import LoadingWheel from "../shared/LoadingWheel";
import ComboBoxInput from "../shared/Inputs/ComboBoxInput";

import useCategorySearchTerms from "../../data/Category/useCategorySearchTerms";

import { useSearchParams } from 'react-router-dom';
import { ICategorySearchTerm } from "../../models/Category/Category";

export function CategorySearchTermSelect ({
    register,
    registerName = "categorySearchTerm",
    setValue,
    initialValue,
    label,
}: {
    register: any;
    registerName?: string;
    setValue: any;
    initialValue?: string;
    label?: string;
}) {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { terms: allTerms } = useCategorySearchTerms();
    const [terms, setTerms] = useState<any[]>();

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (allTerms.isLoading || !allTerms.data) return;

        setTerms(allTerms.data.map((term) => ({
            id: term.id.toString(),
            name: `${term.include ?? "N/A"} : ${term.exclude ?? "N/A"}`,
            include: term.include,
            exclude: term.exclude,
        })));
        setIsLoading(false);
    }, [allTerms.isLoading, allTerms.data, searchParams]);

    if (isLoading) return <LoadingWheel />;

    return (
        <ComboBoxInput
            label={label}
            options={terms}
            register={register}
            searchField={"name"}
            registerName={registerName}
            setValue={setValue}
            initialValue={searchParams.get("categorySearchTermId") ?? initialValue}
        />
    );
}